//#region src/core/i18n/locales/nl.ts
var nl_default = {
	buttons: {
		play: "Afspelen",
		pause: "Pauzeren",
		replay: "Opnieuw afspelen",
		mute: "Dempen",
		unmute: "Dempen uit"
	},
	seek: {
		forward: "{seconds} seconden vooruit",
		backward: "{seconds} seconden terug"
	},
	fullscreen: {
		enter: "Volledig scherm",
		exit: "Volledig scherm verlaten"
	},
	captions: {
		enable: "Ondertiteling inschakelen",
		disable: "Ondertiteling uitschakelen"
	},
	pip: {
		enter: "Beeld-in-beeld starten",
		exit: "Beeld-in-beeld stoppen"
	},
	live: {
		playing: "Speelt live",
		seekToEdge: "Ga naar live",
		badge: "Live"
	},
	cast: {
		start: "Casten starten",
		stop: "Casten stoppen",
		connecting: "Verbinden"
	},
	airplay: {
		start: "AirPlay starten",
		stop: "AirPlay stoppen"
	},
	slider: { seek: "Spoelen" },
	time: {
		current: "Huidige tijd",
		duration: "Tijdsduur",
		remaining: "Resterende tijd",
		elapsedSuffix: "{duration} verstreken tijd",
		durationSuffix: "{duration} duur",
		remainingSuffix: "Nog {duration}",
		showElapsed: "Verstreken tijd tonen, {duration}.",
		showDuration: "Duur tonen, {duration}.",
		showRemaining: "Resterende tijd tonen, {duration}.",
		toggleElapsed: "Schakel tussen verstreken en resterende tijd.",
		toggleDuration: "Schakel tussen duur en resterende tijd.",
		position: "{current} van {duration}",
		unknown: "Media niet geladen, onbekende tijd."
	},
	playback: { rate: "Afspeelsnelheid {rate}" },
	volume: {
		mutedValue: "{percent}, gedempt",
		muted: "Gedempt",
		label: "Geluidsniveau",
		value: "Geluidsniveau {value}"
	},
	status: {
		captionsOn: "Ondertiteling aan",
		captionsOff: "Ondertiteling uit",
		paused: "Gepauzeerd",
		playing: "Wordt afgespeeld",
		fullscreen: "Volledig scherm",
		pip: "Beeld-in-beeld",
		exitPip: "Beeld-in-beeld verlaten",
		seekedTo: "Gesprongen naar {time}"
	},
	container: { label: "Mediaspeler" },
	errors: {
		aborted: "U heeft het afspelen van de media afgebroken",
		network: "Een netwerkfout heeft ervoor gezorgd dat het downloaden van de media is mislukt.",
		decode: "Het afspelen van de media werd afgebroken vanwege een corruptieprobleem of omdat de uw browser de gebruikte mediafuncties niet ondersteund.",
		source: "De media kon niet worden geladen, doordat de server of het netwerk faalde of doordat het formaat niet wordt ondersteund.",
		encrypted: "De media is gecodeerd en we hebben niet de sleutels om het te decoderen.",
		unplayable: "Deze media wordt niet ondersteund door de speler.",
		title: "Er is iets misgegaan.",
		unexpected: "Er is een fout opgetreden. Probeer het opnieuw."
	},
	common: {
		empty: "",
		ok: "Sluiten"
	},
	menu: {
		settings: "Instellingen",
		quality: "Kwaliteit",
		audio: "Geluid",
		default: "Standaard",
		speed: "Snelheid",
		captions: "Ondertiteling",
		playbackRate: "Afspeelsnelheid",
		back: "Terug",
		off: "Uit",
		auto: "Auto",
		autoWithLabel: "Auto ({label})",
		subtitles: "Ondertiteling"
	}
};
//#endregion
export { nl_default as default };

//# sourceMappingURL=nl.js.map